import { ThunkActionType } from 'store/store';
import { Token } from 'enum/Token';
import {
  getLoggedUserApi, logoutApi,
} from 'services/api/authApi';
import { LOGIN_URL, VAULT_SERVICE_URL } from 'constants/serviceUrls';
import { handleApiError } from 'store/app/appThunk';
import { toDataURL } from 'services/api/dataApi';
import { mapServicesWithAccounts } from 'utils/mapServicesWithAccounts';
import {
  resetAuthState, setAvatar, setIsAuth, setServices, setUser,
} from './authReducer';

export const redirectToLogin = (isHard?: boolean) => {
  const pathName = isHard ? window.location.origin : window.location.href;
  window.location.assign(`${LOGIN_URL}${pathName}`);
};

export const getUserData = (): ThunkActionType => {
  return async (dispatch) => {
    try {
      const res = await getLoggedUserApi();

      if (res.avatar) {
        toDataURL(`${VAULT_SERVICE_URL}${res.avatar}`, (avatar) => dispatch(setAvatar(avatar)));
      }

      dispatch(setUser(res));
      dispatch(setServices(mapServicesWithAccounts(res.services ?? [], res.accounts ?? [])));
      dispatch(setIsAuth(true));
    } catch (error: any) {
      redirectToLogin();
    }
  };
};

export const resetAuth = (): ThunkActionType => async (dispatch) => {
  dispatch(resetAuthState());
};

export const logoutAccount = (): ThunkActionType => {
  return async (dispatch) => {
    try {
      if (localStorage.getItem(Token.REFRESH_TOKEN)) {
        await logoutApi();

        localStorage.removeItem(Token.ACCESS_TOKEN);
        localStorage.removeItem(Token.REFRESH_TOKEN);
        dispatch(resetAuth());
        redirectToLogin(true);
      }
    } catch (err) {
      dispatch(handleApiError(err));
    }
  };
};
